/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import _ from 'lodash';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import { ErrorAlert } from '../ErrorAlert';
import NotificationItem from './NotificationItem';

const NOTIFICATIONS = gql`
    query userNotifications($user_uid: String, $searchFilter: SearchParams) {
		userNotifications(user_uid: $user_uid, searchFilter: $searchFilter)
    }
`;

const NEW_NOTIFICATION = gql`
	subscription newNotification($user_uid: String) {
		newNotification(user_uid: $user_uid)
	}
`;

const Index = (props) => {
	const { 
		onSelectedItem, onChange, empid, ...rest 
	} = props;

	const [searchText, setSearchText] = useState('');

	const { loading, error, data, subscribeToMore } = useQuery(NOTIFICATIONS, { 
		fetchPolicy: 'cache-and-network',
		variables: {
			user_uid: empid,
			searchFilter: { page: 1, pageSize: 10, searchText }
		}
	});
	if (error) return <ErrorAlert errorMessage={error.message} />;

	let notifications = _.has(data,'userNotifications') ? data.userNotifications.data : [];
	const unreadNotifications = _.filter(notifications, (i) => (i.is_seen == 0));
				
	return (
		<NotificationItem 
			{...rest }
			notifications={notifications}
			unreadNotifications={unreadNotifications}
			subscribeToNewNotifications={() => 
				subscribeToMore({
					document: NEW_NOTIFICATION,
					variables: { user_uid: empid },
					updateQuery: (prev, { subscriptionData }) => {
						if (!subscriptionData.data) return prev;
						// console.log('[NEW_NOTIFICATION] prev', prev);
						// console.log('[NEW_NOTIFICATION] subscriptionData', subscriptionData);
						return Object.assign({}, prev, {
							userNotifications: subscriptionData.data.newNotification
						});
					}
				})
			}
		/>
	);
};

export default Index;